module.exports = __webpack_public_path__ + "img/bank-note-02.15f0fe7e.svg";